<template>
  <div class="d-flex flex-column mh-0">
    <remove-body-scroll-gutter />
    <initiatives-view
      class="px-sm-0 px-lg-4"
      ref="view"
      :team-id="teamId"
      :org-id="orgId"
      :sub-org-id="subOrgId"
      :query="query"
      :selected-timeline="selectedTimeline"
      :show-parent="true"
      :default-filters-list="['resolution', 'show']"
      v-if="isFilterParamsReady"
    />
  </div>
</template>

<script>
import InitiativesView from '@/components/board/InitiativesView'
import RemoveBodyScrollGutter from '@/components/RemoveBodyScrollGutter.vue'
import { goalsTabIds } from '@/constants/goals'
import { VIEW_QUERY_PARAM } from '@/constants/initiative'
import { STORAGE_KEYS } from '@/constants/storage'
import TeamMixin from '@/mixins/TeamMixin'
import cleanJSON from '@/utils/cleanJSON'
import localStorage from '@/utils/localStorage'
import safeJSONParse from '@/utils/safeJSONParse'
import * as R from 'ramda'

const groupByKey = 'groupBy'
const filterKeys = ['resolution', 'show', 'filterOp']
const queryKeys = [...filterKeys, groupByKey, VIEW_QUERY_PARAM]

/**
 * This is wrapper of InitiativesView, which adds filter preference preservation feature
 */
export default {
  name: 'TeamInitiativesView',
  props: ['teamId', 'orgId', 'query', 'selectedTimeline'],
  components: {
    RemoveBodyScrollGutter,
    InitiativesView
  },
  mixins: [TeamMixin],
  data() {
    return {
      isFilterParamsReady: false
    }
  },
  computed: {
    subOrgId() {
      return this.getClosestOrgLikeTeamId(this.teamId)
    }
  },
  methods: {
    saveFilterPreference() {
      const preference =
        safeJSONParse(localStorage.getItem(STORAGE_KEYS.teamFilterPreference)) || {}
      const updatedPreference = R.assocPath(
        [this.teamId, goalsTabIds.initiatives],
        this.query,
        preference
      )
      localStorage.setItem(STORAGE_KEYS.teamFilterPreference, updatedPreference)
    },
    getStoredQuery() {
      const preference =
        safeJSONParse(localStorage.getItem(STORAGE_KEYS.teamFilterPreference)) || {}
      return preference[this.teamId]?.[goalsTabIds.initiatives]
    },
    /**
     * Returns true if any of the item in the supplied array (keysList) is present in this.query
     * @param keysList
     * @returns {boolean}
     */
    isAvailableInQuery(keysList) {
      const appliedFilters = R.pickBy(Boolean, R.pick(keysList, this.query))
      return Object.keys(appliedFilters).length > 0
    },
    isFilterOrGroupingApplied() {
      return this.isAvailableInQuery(queryKeys)
    },
    replaceQuery(query) {
      query = cleanJSON(query)
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          ...query,
          timeline: this.selectedTimeline.id
        }
      })
    }
  },
  mounted() {
    const savedQueryJSON = this.getStoredQuery()
    const currentQuery = R.pick(queryKeys, this.query)
    if (
      Object.keys(savedQueryJSON || {}).length > 0 &&
      !this.isFilterOrGroupingApplied() &&
      !R.equals(savedQueryJSON, currentQuery)
    ) {
      this.replaceQuery(savedQueryJSON)
    } else {
      !R.isEmpty(currentQuery) && this.saveFilterPreference()
      this.isFilterParamsReady = true
    }
  },
  watch: {
    query() {
      this.saveFilterPreference()
      this.isFilterParamsReady = true
    }
  }
}
</script>

<style lang="scss" scoped></style>
